﻿import "./extensions"

$(() => {
	$("input[data-val-length-max]").add("textarea[data-val-length-max]").filter("[data-character-count]").each((index, element) => {
		let $element = $(element),
			maximum = parseFloat($element.data("valLengthMax")) || 0,
			offset = maximum - $element.valAsString().length,
			$widget = $(`<div class='character-counter'>${offset}</div>'`);

		$element.on("input", () => {
			offset = (maximum - $element.valAsString().length);

			$widget.text(offset);

			$widget[offset < 0 ? "addClass" : "removeClass"]("invalid");
		});

		$element.after($widget);
	});
});
